import { useEffect, useState } from 'react';

import type { RefObject } from 'react';

interface ScrollPositionType {
  x: number;
  y: number;
}
const useScroll = (
  ref?: RefObject<HTMLElement>,
): ScrollPositionType => {

  const [position, setPosition] = useState<ScrollPositionType>({
    x: 0,
    y: 0
  });

  useEffect(() => {   
    if (!ref?.current) {
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
    const element = ref.current;
    if (element) {
      element.addEventListener('scroll', handleScroll);
      return () => {
        element.removeEventListener('scroll', handleScroll);
      };
    }
  }, [ref]);

  const handleScroll = () => {
    const x = ref?.current ? ref.current.scrollLeft : window.pageXOffset;
    const y = ref?.current ? ref.current.scrollTop : window.pageYOffset;
    setPosition({ x, y });
  };

  return position;

};

export default useScroll;